export const About = () => {
  return (
    <div id='about' className='row'>
      <div className='col-12 text-center'>
        <h1 className='section-title'>About me</h1>
      </div>
      <div className='col-1 col-md-2'></div>
      <div className='col-10 col-md-8 fs-4 mt-5 mb-5'>
        Senior frontend developer with 5+ years of experience building and maintaining scalable web applications in
        multiple industries.
        Skilled in developing responsive, high-performance user interfaces using React and Next.js, with a strong focus on
        usability, performance, and clean architecture.
        Contributed to the development and adoption of a reusable design system that improved consistency, accelerated
        development workflows, and supported the continuous delivery of new product features.
      </div>
      <div className='col-1 col-md-2'></div>
    </div>
  )
}
